/*
 * Handles search requests for snippets.
 */

define(["jquery", "backbone", "configuration/properties", "messaging/messenger"], function (
  $,
  Backbone,
  Properties,
  Messenger,
) {
  "use strict";

  const SnippetsSearchModel = {};

  SnippetsSearchModel.snippetSearch = Backbone.Model.extend({
    defaults: {
      name: "",
      description: "",
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return `${Properties.rootURL}/${kbId}/snippets/${this.get("snippetId")}`;
    },
  });

  return SnippetsSearchModel;
});
